import classNames from "classnames";

export const RequestInput = ({
    value,
    onChange,
    name,
    type,
    isInvalid,
    caption
}) => {
    return (
        <div className="flx-rw c-al req-input">
            <label htmlFor="areaCode" className="req-caption">{caption}</label>
            <input
                type={type}
                name={name}
                className={classNames("form-input", {'invalid': isInvalid})}
                value={value}
                onChange={onChange}
            />
        </div>
    )
}